import { make } from 'vuex-pathify'
import { getPricingConfig } from '@constants'

const getDefaultState = ($config) => {
  const config = getPricingConfig($config)
  return {
    plusExtraLang: false,
    premiumExtraLang: false,
    plusOption: config.PLUS_YEAR.idEN,
    premiumOption: config.PREMIUM_YEAR.idEN
  }
}

const state = () => ({
  plusExtraLang: false,
  premiumExtraLang: false,
  plusOption: null,
  premiumOption: null
})

const mutations = {
  ...make.mutations(state),
  SET_DEFAULT_STATE(state, $config) {
    const defaultState = getDefaultState($config)
    Object.assign(state, defaultState)
  }
}

const actions = {
  ...make.actions(state),
  initialize({ commit }, $config) {
    commit('SET_DEFAULT_STATE', $config)
  }
}

const getters = make.getters(state)

export default {
  state,
  getters,
  actions,
  mutations
}
